import React, { useEffect, useState } from "react";
import "./index.scss";
import CardsList from "../../../../core/list-cards";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import CustomCard from "../../../../core/custom-card";
import SAMPLE_ENGINE from "../../../../resources/images/engine-model.png";
import CustomModal from "../../../../core/modal";
import { Icon } from "@iconify/react";
import { getFileExtensionFromUrl } from "../../../../utils";
import moment from "moment";
const WorkshopManual = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [engineWsmDetails, setEngineWsmDetails] = useState({
    isOpen: false,
    data: {},
  });
  const [filters, setFilters] = useState({
    sortBy: "-createdAt",
    page: 1,
    limit: 50,
  });
  const manualCard = (ele) => {
    const addDefaultImg = (ev) => {
      ev.target.src = SAMPLE_ENGINE;
    };
    return (
      <CustomCard>
        <div onClick={() => setEngineWsmDetails({ isOpen: true, data: ele })}>
          <p className="p-margin-0 primary-text worshop-card-text">
            {ele?.engineModel} WSM
          </p>
          <div className="workshop-engine-img-con">
            <img
              src={ele?.image || SAMPLE_ENGINE}
              alt="engine"
              width="100%"
              onError={addDefaultImg}
            />
          </div>
        </div>
      </CustomCard>
    );
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.WORKSHOP_MANUAL}/oem`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results
            ?.map((ele, index) => {
              return {
                ...ele,
                sNo: index + 1,
              };
            })
            .filter((ele) => ele && ele);
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const handleDownload = (ele) => {
    const link = document.createElement("a");
    link.href = ele?.document;
    link.download = `Workshop_Manual_${
      ele?.versionNumber
    }${getFileExtensionFromUrl(ele?.document)}`;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  useEffect(() => {
    loadData(filters);
  }, []);

  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Literature</p>
        <p className="section-name">Workshop Manual</p>
      </div>
      {Object.keys(data).length ? (
        <CardsList
          data={data}
          renderCardFunc={manualCard}
          isLoading={isLoading}
          itemGridSize={2}
          filters={filters}
          onChange={(page) => {
            setFilters((prevVal) => ({ ...prevVal, page }));
            loadData({ ...filters, page });
          }}
        />
      ) : (
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          {" "}
          No Data Found
        </Typography>
      )}
      {engineWsmDetails?.isOpen && (
        <CustomModal
          onClose={() => setEngineWsmDetails({ isOpen: false, data: {} })}
          title={`${engineWsmDetails?.data?.engineModel} Workshop Manual`}
        >
          <Grid
            container
            sx={{ justifyContent: "space-between", mt: 2, gridGap: "10px" }}
          >
            {engineWsmDetails?.data ? (
              <Grid
                item
                md={12}
                sx={{
                  border: "1px solid lightGray",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <IconButton
                    onClick={() => handleDownload(engineWsmDetails.data)}
                    sx={{ padding: "0px" }}
                  >
                    <Icon
                      icon="tabler:download"
                      width="1.2rem"
                      height="1.2rem"
                      style={{ color: "#095adc" }}
                    />
                  </IconButton>
                </Box>
                <Typography variant="body 1" color="gray">
                  Version Number:{" "}
                  <Typography component="span" className="primary-text">
                    {engineWsmDetails?.data?.versionNumber}
                  </Typography>
                </Typography>
                <br />
                <Typography variant="body 1" color="gray">
                  Released on:{" "}
                  <Typography component="span" className="primary-text">
                    {moment(engineWsmDetails?.data?.releasedOn).format(
                      "DD/MM/YYYY"
                    )}
                  </Typography>
                </Typography>
                <br />
                <Typography variant="body 1" color="gray">
                  Remarks:{" "}
                  <Typography component="span" className="primary-text">
                    {engineWsmDetails?.data?.remarks}
                  </Typography>
                </Typography>
              </Grid>
            ) : (
              <Typography sx={{ textAlign: "center", width: "100%" }}>
                Revisions Not Found
              </Typography>
            )}
            <Typography color="error" sx={{ mt: 2 }}>
              WARNING: You are about to access confidential files within the
              software. These files contain sensitive information and are only
              accessible to authorized personnel. Editing / Sharing is strictly
              prohibited.
            </Typography>
          </Grid>
        </CustomModal>
      )}
    </div>
  );
};

export default WorkshopManual;
